import axios from 'axios';
import url from '@/url';

const authHeaders = () => ({
  'X-Authorization': localStorage.getItem('token'),
});

const base = () => `${process.env.VUE_APP_SERVICE_URL}${url.iqra_schedules}`;
const daysBase = () => `${process.env.VUE_APP_SERVICE_URL}${url.iqra_days}`;
const studentsBase = () => `${process.env.VUE_APP_SERVICE_URL}${url.iqra_students}`;
const enrollmentStudentsBase = () => `${process.env.VUE_APP_SERVICE_URL}${url.iqra_students_with_active_subscriptions}`;
const slotTeachersBase = () => `${process.env.VUE_APP_SERVICE_URL}${url.iqra_slot_teachers}`;
const enrollmentsBase = () => `${process.env.VUE_APP_SERVICE_URL}${url.iqra_student_slot_enrollments}`;
const enrollmentsBulkByTeacherBase = () => `${process.env.VUE_APP_SERVICE_URL}${url.iqra_student_slot_enrollments_bulk_by_teacher}`;
const enrollmentsBulkBySlotGroupBase = () => `${process.env.VUE_APP_SERVICE_URL}${url.iqra_student_slot_enrollments_bulk_by_slot_group}`;
const subscriptionPackagesBase = () => `${process.env.VUE_APP_SERVICE_URL}${url.iqra_subscription_packages}`;
const studentSubscriptionsBase = () => `${process.env.VUE_APP_SERVICE_URL}${url.iqra_student_subscriptions}`;
const paymentIntentBase = () => `${process.env.VUE_APP_SERVICE_URL}${url.iqra_subscription_payment_intent}`;
const prayerTimesSyncStatusBase = () => `${process.env.VUE_APP_SERVICE_URL}${url.iqra_prayer_times_sync_status}`;
const prayerTimesResyncBase = () => `${process.env.VUE_APP_SERVICE_URL}${url.iqra_prayer_times_resync}`;

const unwrap = (response, fallback = null) => {
  if (!response?.data?.result) return fallback;
  const { status, data } = response.data.result;
  if (status === 200 || status === 201) {
    return data ?? fallback;
  }
  return fallback;
};

const apiError = (error, fallbackAr) => {
  const message = error?.response?.data?.result?.mesAr || fallbackAr;
  throw new Error(message);
};

export const listIqraSchedules = async (params = {}) => {
  try {
    const response = await axios.get(base(), {
      headers: authHeaders(),
      params,
    });
    return unwrap(response, { data: [], pagination: {} });
  } catch (error) {
    apiError(error, 'فشل في تحميل جداول اقرأ');
  }
};

export const createIqraSchedule = async (payload) => {
  try {
    const response = await axios.post(base(), payload, { headers: authHeaders() });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في إنشاء جدول اقرأ');
  }
};

export const getIqraSchedule = async (scheduleId) => {
  try {
    const response = await axios.get(`${base()}/${scheduleId}`, { headers: authHeaders() });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في جلب جدول اقرأ');
  }
};

export const updateIqraSchedule = async (scheduleId, payload) => {
  try {
    const response = await axios.put(`${base()}/${scheduleId}`, payload, { headers: authHeaders() });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في تحديث جدول اقرأ');
  }
};

export const deleteIqraSchedule = async (scheduleId) => {
  try {
    const response = await axios.delete(`${base()}/${scheduleId}`, { headers: authHeaders() });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في حذف جدول اقرأ');
  }
};

export const assignIqraTeacher = async (scheduleId, payload) => {
  try {
    const response = await axios.post(`${base()}/${scheduleId}/teachers`, payload, { headers: authHeaders() });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في ربط المعلم بجدول اقرأ');
  }
};

export const removeIqraTeacher = async (scheduleId, teacherId) => {
  try {
    const response = await axios.delete(`${base()}/${scheduleId}/teachers/${teacherId}`, { headers: authHeaders() });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في فك ربط المعلم من جدول اقرأ');
  }
};

export const createIqraDay = async (scheduleId, payload) => {
  try {
    const response = await axios.post(`${base()}/${scheduleId}/days`, payload, { headers: authHeaders() });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في إضافة يوم لجدول اقرأ');
  }
};

export const updateIqraDay = async (scheduleId, dayId, payload) => {
  try {
    const response = await axios.put(`${base()}/${scheduleId}/days/${dayId}`, payload, { headers: authHeaders() });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في تحديث يوم جدول اقرأ');
  }
};

export const deleteIqraDay = async (scheduleId, dayId) => {
  try {
    const response = await axios.delete(`${base()}/${scheduleId}/days/${dayId}`, { headers: authHeaders() });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في حذف يوم جدول اقرأ');
  }
};

export const createIqraSlot = async (dayId, payload) => {
  try {
    const response = await axios.post(`${daysBase()}/${dayId}/slots`, payload, { headers: authHeaders() });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في إنشاء فترة اقرأ');
  }
};

export const updateIqraSlot = async (dayId, slotId, payload) => {
  try {
    const response = await axios.put(`${daysBase()}/${dayId}/slots/${slotId}`, payload, { headers: authHeaders() });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في تحديث فترة اقرأ');
  }
};

export const deleteIqraSlot = async (dayId, slotId) => {
  try {
    const response = await axios.delete(`${daysBase()}/${dayId}/slots/${slotId}`, { headers: authHeaders() });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في حذف فترة اقرأ');
  }
};

export const listTeachersForIqra = async () => {
  try {
    const response = await axios.get(`${process.env.VUE_APP_SERVICE_URL}${url.get_all_teachers}`, {
      headers: authHeaders(),
      params: { enabled: true },
    });

    const list = response?.data?.result?.data || [];
    return Array.isArray(list) ? list : [];
  } catch (error) {
    apiError(error, 'فشل في تحميل قائمة المعلمين');
  }
};

export const listIqraStudents = async (params = {}) => {
  try {
    const response = await axios.get(studentsBase(), {
      headers: authHeaders(),
      params,
    });
    return unwrap(response, { data: [], pagination: {} });
  } catch (error) {
    apiError(error, 'فشل في تحميل قائمة طلاب اقرأ');
  }
};

export const getIqraStudentWeeklySchedule = async (studentId, params = {}) => {
  try {
    const response = await axios.get(`${studentsBase()}/${studentId}/weekly-schedule`, {
      headers: authHeaders(),
      params,
    });
    return unwrap(response, {
      student: null,
      schedule_id: null,
      week_start_date: null,
      week_end_date: null,
      lessons: [],
    });
  } catch (error) {
    apiError(error, 'فشل في تحميل جدول الطالب الأسبوعي');
  }
};

export const getIqraPrayerTimesSyncStatus = async (params = {}) => {
  try {
    const response = await axios.get(prayerTimesSyncStatusBase(), {
      headers: authHeaders(),
      params,
    });
    return unwrap(response, {
      summary: { tenant_id: null, expected_regions: 0, last_synced_at: null },
      today: {},
      tomorrow: {},
      days: [],
      pagination: { page: 1, per_page: 7, total: 0, total_pages: 1 },
    });
  } catch (error) {
    apiError(error, 'فشل في جلب حالة مزامنة أوقات الصلاة');
  }
};

export const resyncIqraPrayerTimes = async (payload) => {
  try {
    const response = await axios.post(prayerTimesResyncBase(), payload, {
      headers: authHeaders(),
    });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في إعادة مزامنة أوقات الصلاة');
  }
};

export const listIqraStudentsWithActiveSubscriptions = async (params = {}) => {
  try {
    const response = await axios.get(enrollmentStudentsBase(), {
      headers: authHeaders(),
      params,
    });
    return unwrap(response, { data: [], pagination: {} });
  } catch (error) {
    apiError(error, 'فشل في تحميل الطلاب المؤهلين');
  }
};

export const listIqraSlotTeachers = async (params = {}) => {
  try {
    const response = await axios.get(slotTeachersBase(), {
      headers: authHeaders(),
      params,
    });
    return unwrap(response, []);
  } catch (error) {
    apiError(error, 'فشل في تحميل الفترات المتاحة');
  }
};

export const createIqraStudentSlotEnrollment = async (payload) => {
  try {
    const response = await axios.post(enrollmentsBase(), payload, {
      headers: authHeaders(),
    });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في ربط الطالب بالفترة');
  }
};

export const createIqraStudentSlotEnrollmentsBulkByTeacher = async (payload) => {
  try {
    const response = await axios.post(enrollmentsBulkByTeacherBase(), payload, {
      headers: authHeaders(),
    });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في تنفيذ الربط الجماعي لفترات المعلم');
  }
};

export const createIqraStudentSlotEnrollmentsBulkBySlotGroup = async (payload) => {
  try {
    const response = await axios.post(enrollmentsBulkBySlotGroupBase(), payload, {
      headers: authHeaders(),
    });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في تنفيذ ربط مجموعة الفترات');
  }
};

export const listIqraStudentSlotEnrollments = async (params = {}) => {
  try {
    const response = await axios.get(enrollmentsBase(), {
      headers: authHeaders(),
      params,
    });
    return unwrap(response, { data: [], pagination: {} });
  } catch (error) {
    apiError(error, 'فشل في جلب روابط الطلاب بالفترات');
  }
};

export const updateIqraStudentSlotEnrollment = async (enrollmentId, payload) => {
  try {
    const response = await axios.patch(`${enrollmentsBase()}/${enrollmentId}`, payload, {
      headers: authHeaders(),
    });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في تحديث ربط الطالب بالفترة');
  }
};

export const deleteIqraStudentSlotEnrollment = async (enrollmentId) => {
  try {
    const response = await axios.delete(`${enrollmentsBase()}/${enrollmentId}`, {
      headers: authHeaders(),
    });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في حذف ربط الطالب بالفترة');
  }
};

export const listIqraSubscriptionPackages = async (params = {}) => {
  try {
    const response = await axios.get(subscriptionPackagesBase(), {
      headers: authHeaders(),
      params,
    });
    return unwrap(response, { data: [], pagination: {} });
  } catch (error) {
    apiError(error, 'فشل في جلب باقات الاشتراك');
  }
};

export const createIqraSubscriptionPackage = async (payload) => {
  try {
    const response = await axios.post(subscriptionPackagesBase(), payload, {
      headers: authHeaders(),
    });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في إنشاء باقة الاشتراك');
  }
};

export const updateIqraSubscriptionPackage = async (packageId, payload) => {
  try {
    const response = await axios.put(`${subscriptionPackagesBase()}/${packageId}`, payload, {
      headers: authHeaders(),
    });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في تحديث باقة الاشتراك');
  }
};

export const toggleIqraSubscriptionPackageStatus = async (packageId, isActive) => {
  try {
    const response = await axios.patch(`${subscriptionPackagesBase()}/${packageId}/status`, {
      is_active: isActive,
    }, {
      headers: authHeaders(),
    });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في تحديث حالة الباقة');
  }
};

export const listIqraStudentSubscriptions = async (params = {}) => {
  try {
    const response = await axios.get(studentSubscriptionsBase(), {
      headers: authHeaders(),
      params,
    });
    return unwrap(response, { data: [], pagination: {} });
  } catch (error) {
    apiError(error, 'فشل في جلب اشتراكات الطلاب');
  }
};

export const createIqraStudentSubscription = async (payload) => {
  try {
    const response = await axios.post(studentSubscriptionsBase(), payload, {
      headers: authHeaders(),
    });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في تفعيل اشتراك الطالب');
  }
};

export const updateIqraStudentSubscription = async (subscriptionId, payload) => {
  try {
    const response = await axios.patch(`${studentSubscriptionsBase()}/${subscriptionId}`, payload, {
      headers: authHeaders(),
    });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في تحديث اشتراك الطالب');
  }
};

export const createIqraSubscriptionPaymentIntent = async (payload) => {
  try {
    const response = await axios.post(paymentIntentBase(), payload, {
      headers: authHeaders(),
    });
    return unwrap(response, null);
  } catch (error) {
    apiError(error, 'فشل في إنشاء عملية الدفع');
  }
};

